export default __webpack_public_path__ + "static/media/icon-editor-undo.9dceeb2f.svg";